import { H4 } from 'components/headings';
import { Slide, Slider } from 'pure-react-carousel';
import styled, { Theme } from 'styled-components';
import { ReactComponent as AllWarningsSVG } from '../../assets/images/fire-danger-ratings/fire-danger-ratings-all.svg';

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 90%;
  }
`;

export const AllWarnings = styled(AllWarningsSVG)`
  margin: 0 0 60px 0;
`;

export const TitleText = styled(H4)<{
  backgroundColor: keyof Theme['colors']['palette'];
  textColor?: keyof Theme['colors']['palette'];
}>`
  margin: 15px 0 20px 0;
  padding: 10px 0 10px 0;
  color: ${({ theme, textColor }) =>
    textColor ? theme.colors.palette[textColor] : theme.colors.palette.black};
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor
      ? theme.colors.palette[backgroundColor]
      : theme.colors.palette.white};
`;

export const TagWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    height: 30px;
  }
  svg:not(:first-child) {
    margin-left: 6px;
  }
  img {
    height: 30px;
  }
`;

export const SlideCentred = styled(Slide)`
  text-align: center;
`;

export const FireDangerSlider = styled(Slider)`
  height: 490px;

  ${({ theme }) => theme.mediaQueries.medium} {
    width: 432px;
    height: 480px;
  }
`;

export const AllClearTitleText = styled(TitleText)`
  border-style: solid;
  border-width: 1px 0;
`;
